import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 2rem;
  text-align: center;
`;

export const Icon = styled.div`
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs50};
  margin-bottom: 1rem;
`;

export const Title = styled.h5`
  color: ${({ theme }) => theme.colors?.text?.primary};
  margin-bottom: 0.5rem;
`;

export const Description = styled.p`
  color: ${({ theme }) => theme.colors?.text?.secondary};
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs14};
`;

